export const getFieldErrorMessages = (error: unknown): string | null => {
  const errorData = (error as any)?.response?.data?.error;

  if (!errorData) return null;

  const fields = errorData.fields;
  if (fields && typeof fields === "object") {
    const messages: string[] = [];

    Object.values(fields).forEach((fieldErrors) => {
      if (Array.isArray(fieldErrors)) {
        messages.push(...fieldErrors);
      }
    });

    if (messages.length > 0) {
      return messages.map((msg) => `• ${msg}`).join("\n");
    }
  }

  return errorData.message || null;
};
